import React,{useState,useEffect} from "react";
import API from "../../../utils/API";
import {titleFormatter} from "../utils";

const Duplicate = ({title,type,elementId,onClose}) => {

    const [value, setValue] = useState(null)

    useEffect(() => {
        API.post('/admin/filter',{elementId:elementId,type:type,filterTitle:title}).then((response) => {
            if (response.data.data.data) {
                if (response.data.data.data.value) {
                    setValue(response.data.data.data.value)
                }
            }
        })
    }, [title,type])

    const saveFilter = () => {
        API.put('/admin/filter',{elementId:elementId,type:type,filterTitle:title,data:{value:value}}).then((response) => {
            onClose()
        });
    }

    return (
        <>
            <div className="row">
                <div className="col pt-2">
                    <h5>Filter by: {titleFormatter(title)}</h5>
                </div>
                <div className="col-auto text-right">
                    <button onClick={onClose} className="btn btn-outline-secondary mb-2">X</button><br/>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <input className="form-control" type="number" value={value} onChange={(e)=>setValue(e.target.value)}/>
                </div>
            </div>
            <div className="mt-3 text-center">
                <button className="btn btn-primary" onClick={saveFilter}>Save</button>
            </div>
        </>
    )
}

export default Duplicate;
